import api from './api';

const purchaseOrdersService = {
  // Buscar pedidos de compra de um projeto
  getByProject: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/purchase-orders`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pedidos de compra:', error);
      throw error;
    }
  },

  // Criar pedido de compra a partir do orçamento
  create: async (projectId, data) => {
    try {
      const response = await api.post(`/projects/${projectId}/purchase-orders`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar pedido de compra:', error);
      throw error;
    }
  },

  // Atualizar status do pedido
  updateStatus: async (orderId, status) => {
    try {
      const response = await api.put(`/purchase-orders/${orderId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  },

  // Registrar recebimento de pedido
  receive: async (orderId, data) => {
    try {
      const response = await api.post(`/purchase-orders/${orderId}/receive`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao registrar recebimento:', error);
      throw error;
    }
  },

  // Buscar itens do orçamento que precisam ser comprados
  getBudgetItemsToPurchase: async (projectId) => {
    try {
      const response = await api.get(`/projects/${projectId}/purchase-orders/items-to-buy`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens do orçamento:', error);
      throw error;
    }
  },

  // Listar todos os pedidos de compra (para gerência)
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/purchase-orders', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pedidos de compra:', error);
      throw error;
    }
  },

  // Buscar detalhes de um pedido (com expense vinculado)
  getDetails: async (orderId) => {
    try {
      const response = await api.get(`/purchase-orders/${orderId}/details`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar detalhes do pedido:', error);
      throw error;
    }
  },

  // Buscar parcelas de um pedido
  getInstallments: async (orderId) => {
    try {
      const response = await api.get(`/purchase-orders/${orderId}/installments`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar parcelas do pedido:', error);
      throw error;
    }
  }
};

export default purchaseOrdersService;